<template>
    <div v-if="show">
        <title>Modal Component</title>
        <div name="modal">
            <div class="modal-mask" v-bind:class="{'modal-mask-backdrop': hasBackdrop}" @click="backdropClicked">
                <div class="modal-wrapper">
                    <div class="modal-container" :style="'max-width: ' + width + ';width: ' + width">
                        <span v-if="showCloseButton" @click="closeClicked" class="icon icon-close"></span>
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog",
        props: {
            show: {
                required: true,
                type: Boolean
            },
            hasBackdrop: {
                type: Boolean
            },
            showCloseButton: {
                type: Boolean
            },
            width: {
                type: String,
                default: 'fit-content'
            }
        },
        data: function () {
            return {}
        },
        methods: {
            closeClicked: function () {
                this.close();
            },
            backdropClicked: function (event) {
                if(event.target.classList.contains('modal-wrapper')){
                    this.close();
                }
            },
            close: function () {
                this.$emit('close')
            }
        }
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: table;
    }

    .modal-mask-backdrop {
        background-color: rgba(255, 255, 255, 0.7);
        transition: opacity 0.3s ease;
    }

    .icon {
        position: absolute;
        top: 1rem;
        right: 1rem;
        cursor: pointer;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        min-width: 400px;
        min-height: 200px;
        max-width: 40% !important;
        width: fit-content;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #ffffff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

</style>